var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18px",
    height: "18px",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#6f75bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 17.5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 4c2.4852814 0 4.5 2.01471863 4.5 4.5 0 1.7663751-1.017722 3.2950485-2.4987786 4.031633l-.0012214.968367c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2l-.00021218-.9678653c-1.48160351-.7363918-2.49978782-2.2653584-2.49978782-4.0321347 0-2.48528137 2.01471863-4.5 4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 1.5v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 3.5 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 3.5 1-1",
    transform: "matrix(-1 0 0 1 6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 13.5 1-1",
    transform: "matrix(1 0 0 -1 0 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 13.5 1-1",
    transform: "matrix(-1 0 0 -1 6 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 7.5h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5 7.5h-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.0b627fce7dfefcfd376e57624eedd754.svg";
export { ForwardRef as ReactComponent };